import React from 'react';
import { Card, Table, Chart, Stat, Badge, SectionLabel } from 'nelitomorphism';
import './Activity.css';

const COLUMNS = [
  { key: 'action', label: 'Event' },
  { key: 'repo', label: 'Repository' },
  { key: 'when', label: 'When', align: 'right', mono: true },
];

const Activity = ({ github }) => {
  const { loading, profile, events, activeRepos, years, cumulative, error } = github;

  return (
    <section id="activity">
      <div className="activity-head">
        <SectionLabel meta="github · public" rule>
          Activity
        </SectionLabel>
        <Badge tone="ok" dot pulse>
          Live
        </Badge>
      </div>

      <div className="stat-row">
        <Stat label="Public repos" value={profile?.repos ?? 0} loading={loading} />
        <Stat label="Followers" value={profile?.followers ?? 0} loading={loading} />
        <Stat label="Years on GitHub" value={profile?.years ?? 0} loading={loading} />
        <Stat label="Active repos" value={activeRepos ?? 0} hint="last 90d" loading={loading} glow />
      </div>

      <Card title="Public repositories" meta="cumulative" className="chart-card">
        <Chart data={cumulative} labels={years} type="area" height={140} loading={loading} />
      </Card>

      <Card title="Recent public events" meta="github">
        {!loading && !error && events.length === 0 ? (
          <p className="activity-empty">
            No public activity in the last 90 days.{' '}
            <a href="https://github.com/nelitow" target="_blank" rel="noopener noreferrer">
              View profile →
            </a>
          </p>
        ) : error ? (
          <p className="activity-empty">
            GitHub is unreachable right now.{' '}
            <a href="https://github.com/nelitow" target="_blank" rel="noopener noreferrer">
              View profile →
            </a>
          </p>
        ) : (
          <Table
            columns={COLUMNS}
            rows={events}
            loading={loading}
            loadingRows={8}
            onRowClick={row => window.open(row.url, '_blank', 'noopener')}
          />
        )}
      </Card>
    </section>
  );
};

export default Activity;
